import React from 'react';
import { Tabs, Tab, TabList, TabPanel } from 'react-tabs';
import './react-tabs-custom.css';
import { Link } from 'react-router-dom';
import User from './User';
import { history } from '../store';
import FaQuestionCircle from 'react-icons/lib/fa/question-circle';
import { connect } from 'react-redux';
import { SIGNOUT, LOGIN_APPROVED } from '../constants/actionTypes';
import Loader from 'react-loader';

let firebase

const mapStateToProps = state => {
  return {
    ...state.common,
    isAuthenticated: state.common.isAuthenticated
  }
};

const mapDispatchToProps = dispatch => ({
  onLoginRequested: () => dispatch({ type: SIGNOUT }),
  onLoginApprove: (fbToken) => dispatch({ type: LOGIN_APPROVED, payload: fbToken })
});

class RFRCTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user_sonia: this.props.match.path == '/SONIA' ? <User tabName='SONIA' history={history} /> : null,
      user_sofr: this.props.match.path == '/SOFR' ? <User tabName='SOFR' history={history} /> : null,
      user_estr: this.props.match.path == '/ESTR' ? <User tabName='€STR' history={history} /> : null,
      user_tonar: this.props.match.path == '/TONAR' ? <User tabName='TONAR' history={history} /> : null,
      isFirebaseTokenReceived: false
    }
  }

  componentDidMount() {

    if (this.props.isFirebaseEnabled) {
      firebase = require('./Firebase.js').default
    } else {
      firebase = null
    }

    if (firebase != null) {
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          user.getIdToken().then((data) => {
            const fbToken = data;
            const expirationDuration = 1000 * 60 * 60 * 12 * 2; // 24 hours
            const currentTime = new Date().getTime();
            const verificationEmailTimeStamp = localStorage.getItem("rfr_emvts")
            if (!user.emailVerified && verificationEmailTimeStamp && (currentTime - verificationEmailTimeStamp) > expirationDuration) {
              this.props.onLoginRequested();
              firebase.auth().signOut();
            } else {
              this.props.onLoginApprove(fbToken);
            }
            this.setState({isFirebaseTokenReceived : true})
          });
        }
        else {
          this.props.onLoginRequested();
        }
      });
    }
  }

  getTabIndex(tabName) {
    switch (tabName) {
      case '/SONIA':
        return 0;
      case '/SOFR':
        return 1;
      case '/ESTR':
        return 2;
      case '/TONAR':
        return 3;
      default:
        return 0;
    }
  }
  getTabName(tabIndex) {
    switch (tabIndex) {
      case 0:
        return '/SONIA';
      case 1:
        return '/SOFR';
      case 2:
        return '/ESTR';
      case 3:
        return '/TONAR';
      default:
        return '/SONIA';
    }
  }
  render() {
    const url_path = this.props.match.path
    return (
      <div className="home-page">
        {url_path == '/SONIA' && this.props.isAuthenticated && !this.state.isFirebaseTokenReceived ?
          <div className="text-xs-center spinnerHome">
            <Loader className="loader" color='#6f2c91' scale={1.5} loaded={false} />
          </div> :
          <div className="container page">
            <div className="container-user">
              <Tabs
                selectedIndex={this.getTabIndex(this.props.match.path)}
                onSelect={
                  tabIndex => {
                    try {
                      history.push(this.getTabName(tabIndex));
                      if (tabIndex == 0) {
                        this.state.user_sonia = this.state.user_sonia != null ? this.state.user_sonia : <User tabName='SONIA' history={history} />;
                      }
                      else if (tabIndex == 1) {
                        this.state.user_sofr = this.state.user_sofr != null ? this.state.user_sofr : <User tabName='SOFR' history={history} />;
                      }
                      else if (tabIndex == 2) {
                        this.state.user_estr = this.state.user_estr != null ? this.state.user_estr : <User tabName='€STR' history={history} />;
                      }
                      else if (tabIndex == 3) {
                        this.state.user_tonar = this.state.user_tonar != null ? this.state.user_tonar : <User tabName='TONAR' history={history} />;
                      }
                      else {
                        this.state.user_sonia = this.state.user_sonia != null ? this.state.user_sonia : <User tabName='SONIA' history={history} />;
                      }
                    } catch (error) {
                      console.log(error)
                    }

                  }}
                forceRenderTabPanel={true}
              >
                <TabList>
                  <Tab name='SONIA'><Link to="/SONIA">SONIA</Link></Tab>
                  <Tab name='SOFR'><Link to="/SOFR">SOFR</Link></Tab>
                  <Tab name='ESTR'><Link to="/ESTR">€STR</Link></Tab>
                  <Tab name='TONAR'><Link to="/TONAR">TONAR</Link></Tab>
                </TabList>
                <TabPanel>{this.state.user_sonia}</TabPanel>
                <TabPanel>{this.state.user_sofr}</TabPanel>
                <TabPanel>{this.state.user_estr}</TabPanel>
                <TabPanel>{this.state.user_tonar}</TabPanel>
              </Tabs>
              <div name='Help' className="help-user small" onClick={() => { history.push('./Help') }}><FaQuestionCircle className="tabs-help-icon" />Help</div>
            </div>
          </div>
        }
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RFRCTab);




// WEBPACK FOOTER //
// ./src/components/Tabs.js